// extracted by mini-css-extract-plugin
export default {"body":"SignInDetail_body__qfv6O","isNumbering":"SignInDetail_isNumbering__93sRr","right":"SignInDetail_right__I5VsE"};